import React from "react";
import { observer } from "mobx-react";
import { Container } from "@mui/material";
import RootStore from "../stores/RootStore";

const { uiStore } = RootStore;

function BottomBar(props) {
  uiStore.setBottomBarHeight(0);
  return (
    <div style={{
      position: "absolute",
      bottom: 0,
      width: "100%",
      height: props.height,
      maxHeight: props.height,
      minHeight: props.height,
      background: "white"
    }}>
      <Container style={{
        bottom: 0,
        width: "100%",
        height: props.height,
        maxHeight: props.height,
        minHeight: props.height,
        background: "white"
      }}></Container>
    </div>
  );
}
export default observer(BottomBar);
